module.exports = "./img/e3fabdec0a32060b9a70cac5fb4ab133.jpg";